import { AsyncBoundary } from "@components/AsyncBoundary";
import { type ReactNode } from "react";

export const CompanionPanel = ({
  skeleton,
  fallback,
  children,
}: {
  skeleton: ReactNode;
  fallback: (retry: () => void) => ReactNode;
  children: ReactNode;
}) => (
  <div className="flex h-full flex-col gap-3 font-companion">
    <AsyncBoundary skeleton={skeleton} fallback={fallback}>
      {children}
    </AsyncBoundary>
  </div>
);
